import { Link } from 'react-router-dom';
import ham from '../assets/icons/ham.png';
import notification from '../assets/icons/notification.png';
import profile from '../assets/icons/Profile.png';
import { useRecoilState } from 'recoil';
import navHeaderAtom from '../atoms/navHeaderAtom';
import { useEffect, useState } from 'react';

function Nav({ showMenu, setShowMenu, setShowNotification }) {
  const [ header ] = useRecoilState(navHeaderAtom)
  const [ notificationCount, setNotificationCount ] = useState(0)

  useEffect(() => {
    setInterval(() => {
      indexedDB.databases()
        .then(dbs => {
            const db = dbs.filter(db => db.name === 'notifications-db')
            if(db.length > 0) {
              getStoredNotifications().then((fetchedNotifications) => {
                // console.log(fetchedNotifications)
                  setNotificationCount(fetchedNotifications.length);
              });
          }
        })
    }, 5000)
  }, [])

  function getStoredNotifications() {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open('notifications-db', 1);
    
        request.onsuccess = function(event) {
            const db = event.target.result;
            const transaction = db.transaction(['notifications'], 'readonly');
            const store = transaction.objectStore('notifications');
            const getAll = store.getAll();
    
            getAll.onsuccess = function() {
            resolve(getAll.result);
            };
    
            getAll.onerror = function() {
            reject('Error retrieving notifications');
            };
        };
    
        request.onerror = function() {
            reject('Error opening database');
        };
    });
};



    return(
      <div className='flex justify-between sticky top-0 items-center p-4 bg-white z-50'>
        <div>
            <img src={ham} alt='logo' className='h-5 w-5 cursor-pointer' onClick={() => setShowMenu(!showMenu)}/>
        </div>
        <div className='font-bold text-lg pl-8'>{header}</div>
        <div className='flex justify-center items-center'>
            <img src={notification}  className="h-5 w-5 mr-3 cursor-pointer" alt='Notification Bell'  onClick={() => setShowNotification(true)}/>
            <span className='text-xs font-semibold -ml-5 -mt-6 rounded-full bg-red-700 px-1 text-white'>{notificationCount}</span>
            <Link to={'/profile'}><img src={profile} alt='userIcon' className='rounded-full h-6 w-6'  /></Link>
        </div>
      </div>
    )
}

export default Nav;